import { j as t } from "../../jsx-runtime-BwWtxLpl.js";
import M from "classnames";
import { forwardRef as N, useContext as $, Children as h, isValidElement as v } from "react";
import { IconoirNavArrowLeft as F, IconoirNavArrowRight as R } from "@ey-xd/motif-icon";
import { MotifIcon as l } from "../icon/icon.js";
import { IconContext as T } from "../icon/icon.context.js";
import { MotifProgressBar as A } from "../progress-bar/progress-bar.js";
const E = {
  previous: F,
  next: R
}, q = N(
  ({
    variant: o = "primary",
    className: x = "",
    disabled: b = !1,
    size: m = "small",
    children: n,
    stepper: e = null,
    type: i = "submit",
    loading: r = !1,
    progress: f = null,
    onClick: d,
    icons: c = { previous: null, next: null },
    warn: p = !1,
    ...j
  }, I) => {
    const u = o === "text" || o === "text-alt" ? "isText" : "isButton", w = (r || i === "loader") && !f, { button: a } = $(T), B = h.count(n) === 1 && v(n) && n.type === l;
    let s;
    a ? s = {
      ...a,
      ...c
    } : s = {
      ...E,
      ...c
    };
    const C = M({
      [`motif-button-stepper-${e}`]: u === "isButton" && n && e,
      [`motif-button motif-${o}-button`]: u === "isText",
      [`motif-button motif-button-${o}`]: u === "isButton",
      "motif-loader-button": i === "loader" || r,
      [`motif-button-${m}`]: m,
      "motif-button-warn": p || o === "warn",
      "motif-button-icon-only": B,
      [x]: !0
    });
    return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsxs("button", { ...j, type: i === "loader" ? "submit" : i, className: C, disabled: b, onClick: d, ref: I, children: [
      e === "prev" && /* @__PURE__ */ t.jsx(l, { iconFunction: s.previous, fill: "none" }),
      n,
      (i === "loader" || r) && /* @__PURE__ */ t.jsx(A, { hideLabel: !0, value: f, isIndeterminate: w }),
      e === "next" && /* @__PURE__ */ t.jsx(l, { iconFunction: s.next, fill: "none" })
    ] }) });
  }
);
export {
  q as MotifButton
};
